var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStBarts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.79 511.581C397.059 511.581 511.58 397.06 511.58 255.791C511.58 114.522 397.059 0.000976562 255.79 0.000976562C114.521 0.000976562 0 114.522 0 255.791C0 397.06 114.521 511.581 255.79 511.581Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.714 205.745H372.563C372.563 190.39 360.115 177.942 344.76 177.942L322.517 222.427C322.517 222.427 346.243 289.155 345.501 289.155H373.304C388.66 289.155 401.107 276.708 401.107 261.352C416.463 261.352 428.91 248.905 428.91 233.549H427.984C443.339 233.548 456.714 221.101 456.714 205.745Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8652 205.745H139.016C139.016 190.39 151.464 177.942 166.819 177.942L189.062 222.427C189.062 222.427 165.336 289.155 166.078 289.155H138.275C122.919 289.155 110.472 276.708 110.472 261.352C95.1162 261.352 82.6692 248.905 82.6692 233.549H83.5952C68.2392 233.548 54.8652 221.101 54.8652 205.745V205.745Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.76 355.882V367.003H166.819V355.882H122.334V400.367H166.819V411.488H344.76V400.367H389.245V355.882H344.76Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.819 177.941V289.153C166.819 357.256 255.789 378.124 255.789 378.124C255.789 378.124 344.759 357.256 344.759 289.153V177.941L255.789 166.82L166.819 177.941Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.82 222.431H344.76V289.159H166.82V222.431Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.274 122.335V139.017L289.153 144.578L278.032 133.456V100.092H233.547V133.456L222.426 144.578L211.304 139.017V122.335H166.819V177.941H344.76V122.335H300.274Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 511.58,
    height: 511.58,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStBarts);
export default __webpack_public_path__ + "static/media/stBarts.a71023b20a2e2cc58eabff888ce30963.svg";
export { ForwardRef as ReactComponent };